const heightCell = 48;

const streamStyle = {
    columnDate: {
        width: '13%',
        height: heightCell
    },
    columnTitle: {
        width: '65%',
        height: heightCell
    },
    columnStatus: {
        width: '22%',
        height: heightCell,
        paddingLeft: 18
    },
    columnCell: {
        padding: '14px 0 0 22px',
        whiteSpace: 'normal',
        verticalAlign: 'top'
    }
};

export default streamStyle;


// WEBPACK FOOTER //
// src/components/streams/stream-style.js